/**
 * RunnerAvatarV2 Component
 * Dark circle with white initials (Pencil `1OiYa`)
 * 40px default, 36px small variant
 */

interface RunnerAvatarV2Props {
  firstName: string;
  lastName: string;
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

export function RunnerAvatarV2({ firstName, lastName, size = 'default', className = '' }: RunnerAvatarV2Props) {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  const sizeClass = size === 'sm' ? 'v2-avatar--sm' : size === 'lg' ? 'v2-detail-avatar v2-avatar' : '';

  return (
    <div className={`v2-avatar ${sizeClass} ${className}`}>
      {initials}
    </div>
  );
}
